if (!customElements.get('cma-silent-slideshow')) {
  customElements.define('cma-silent-slideshow', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('[data-cma-slide]'));
      this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      this.interval = Math.max(3000, Number(this.dataset.interval || 7000));
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.setAttribute('role', 'region');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', () => this.motion.matches ? this.stop() : this.start(), opts);
      this.show(this.index);
      this.start();
      window.addEventListener('resize', () => this.updateHeight(), opts);
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.stop(); else this.start(); }, opts);
      document.addEventListener('shopify:block:deselect', () => this.start(), opts);
      document.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('[data-cma-slide]');
        if (!slide || !this.contains(slide)) return;
        this.stop();
        this.show(this.slides.indexOf(slide));
      }, opts);
    }
    disconnectedCallback() {
      this.stop();
      this.abort?.abort();
      this.initialized = false;
    }
    start() {
      if (this.slides.length < 2 || document.hidden || this.timer || this.motion.matches) return;
      this.timer = window.setInterval(() => this.show((this.index + 1) % this.slides.length), this.interval);
    }
    stop() {
      window.clearInterval(this.timer);
      this.timer = null;
    }
    updateHeight() {
      const slide = this.slides[this.index];
      if (!slide || slide.dataset.customHeight !== 'true') { this.style.height = ''; return; }
      const height = Number(window.matchMedia('(max-width:768px)').matches ? slide.dataset.heightMobile : slide.dataset.heightDesktop);
      this.style.height = Number.isFinite(height) && height > 0 ? `${height}px` : '';
    }
    show(index) {
      this.index = index;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', String(i !== index));
        slide.inert = i !== index;
      });
      this.updateHeight();
    }
  });
}
